import { useEffect, useMemo, useState } from 'react';
import { supabase } from '../config/supabase';

export const useFaqItems = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFaqItems = async () => {
      try {
        setLoading(true);
        setError(null);

        console.log('🔍 Fetching FAQ items...');
        const { data, error: fetchError } = await supabase
          .from('faq_items')
          .select('id, question_en, answer_en, display_order, category')
          .eq('is_active', true)
          .order('display_order', { ascending: true });

        console.log('📊 FAQ response:', { data, error: fetchError });

        if (fetchError) {
          console.error('❌ FAQ fetch error:', fetchError);
          throw fetchError;
        }

        console.log(`✅ Loaded ${data?.length || 0} FAQ items`);
        setItems(data ?? []);
      } catch (err) {
        console.error('❌ Error fetching FAQ items:', err);
        setError(err.message || 'Failed to load FAQs');
        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    fetchFaqItems();
  }, []);

  const categories = useMemo(() => {
    const categoryMap = new Map();
    items.forEach(item => {
      const category = item.category || 'general';
      if (!categoryMap.has(category)) {
        categoryMap.set(category, []);
      }
      categoryMap.get(category).push(item);
    });
    return categoryMap;
  }, [items]);

  return { items, categories, loading, error };
};

